var u = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
export {
  u as SPACE_SEPARATOR_REGEX
};
